import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getLedger(payload) {
    const result = await axios.post(apiUrl + "/admin/ledger",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getTrialBalance(payload) {
    const result = await axios.post(apiUrl + "/payment/get/trialbalance",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const LedgerServices = {
    getLedger,
    getTrialBalance
}